<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';
    import { setScrollId } from '$lib/utils/setScrollId';

    import Limiter from './Limiter.svelte';
    import Transition from './Transition.svelte';
    import { getBgStyles } from '../_utils/getBgStyles';

    import type { LeftCenterAlign, Padding } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let top: Padding = 'medium';
    export let right: Padding = 'medium';
    export let bottom: Padding = 'medium';
    export let left: Padding = 'medium';
    export let backgroundColor = 'transparent';
    export let bgImage = {
        visible: false,
        src: '',
        opacity: 0,
        focalPoint: { x: 0, y: 0 },
    };
    export let className = '';
    export let rounded = false;
    export let fullHeight = false;
    export let grow = false;

    // Transition
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';

    // Limiter
    export let narrow = false;
    export let medium = false;
    export let wide = false;
    export let desktop = false;
    export let align: LeftCenterAlign = 'center';

    let paddingClasses: string;

    $: paddingClasses = cn(className, {
        'fun-pt-2': top === 'small',
        'fun-pt-4': top === 'medium',
        'fun-pt-6': top === 'large',
        'fun-pt-8': top === 'xLarge',
        'fun-pl-2': left === 'small',
        'fun-pl-4': left === 'medium',
        'fun-pl-6': left === 'large',
        'fun-pl-8': left === 'xLarge',
        'fun-pr-2': right === 'small',
        'fun-pr-4': right === 'medium',
        'fun-pr-6': right === 'large',
        'fun-pr-8': right === 'xLarge',
        'fun-pb-2': bottom === 'small',
        'fun-pb-4': bottom === 'medium',
        'fun-pb-6': bottom === 'large',
        'fun-pb-8': bottom === 'xLarge',
    });
</script>

<div
    {...setScrollId(id)}
    class={cn('fun-border-box fun-relative fun-w-full fun-bg-cover', paddingClasses, {
        [getBorderRadius('blockFrame')]: rounded,
        'fun-h-full': fullHeight,
        'fun-flex-grow': grow,
    })}
    style:background={backgroundColor}
>
    <!-- Background Image -->
    {#if bgImage.visible && bgImage.src}
        <div
            class={cn(
                'fun-pointer-events-none fun-absolute fun-inset-0 fun-bg-cover fun-bg-no-repeat',
                {
                    [getBorderRadius('blockFrame')]: rounded,
                },
            )}
            style={getBgStyles(bgImage)}
        />
    {/if}

    <Limiter {narrow} {medium} {wide} {fullHeight} {desktop} {align}>
        <Transition delay={transitionDelay} effect={transitionEffect} {fullHeight}>
            <slot />
        </Transition>
    </Limiter>
</div>
